.purchase_global {
	margin-right: 20px !important;
	margin-left: 20px !important;
	margin-top: 5px;
	padding-bottom: 1em;

	.purchase_content {
		min-height: 82vh;
		max-height: 82vh;
		display: flex;
		flex-direction: column;

		width: 100%;
		box-shadow: 5px 5px 10px #dfe1e6;
		background-color: white;

		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin-bottom: 5px;

		@media (max-width: 820px) {
			min-height: 77vh;
			max-height: 77vh;
		}

		@media (max-width: 400px) {
			min-height: 73vh;
			max-height: 73vh;
			box-shadow: none;
		}

		.header {
			height: 10%;
			flex-wrap: wrap;
			align-items: center;
			border-bottom: 0.5px solid #dee2e6;
		}

		.actions {
			height: 10%;

			.actionRow {
				display: flex;
				align-items: center;

				.label {
					display: inline-flex;
					width: 7%;
					font-size: 13px;
				}

				.optionButton {
					display: inline-flex;
					background-color: #fafafa;
					padding: 7px 10px;
					border-radius: 10px;
					font-size: 13px;
					font-weight: 400;
					margin-right: 10px;
					cursor: pointer;
					max-width: 15em;

					span {
						margin-left: 30px;

						div {
							display: inline-flex;
							font-weight: 700;
						}
					}

					&:hover {
						background-color: #7fb02f;
						color: white;
					}

					.icon {
						margin-right: 7px;
						margin-top: 3px;
					}

					&.editInventory {
						background-image: url("../../assets/images/desktop/editar1.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/editar2.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/editar2.svg");
							color: white;
							background-color: #7fb02f;
						}
					}

					&.printEmpty {
						background-image: url("../../assets/images/desktop/imprimir1.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/imprimir2.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/imprimir2.svg");
							color: white;
							background-color: #7fb02f;
						}
					}

					&.deleteInventory {
						background-image: url("../../assets/images/desktop/eliminar1.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/eliminar2.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/eliminar2.svg");
							color: white;
							background-color: #7fb02f;
						}
					}
				}
			}

			.separator {
				width: 98%;
				margin-top: 1px;
				margin-bottom: 5px;
			}
		}

		.headerTable {
			padding-left: 5px;
			padding-right: 5px;
			height: 8%;

			@media (max-width: 820px) {
				display: none;
			}
		}

		.table {
			height: 88%;
			overflow-y: auto;

			border-collapse: separate;
			border-spacing: 0 1em;
			display: flex;
			align-content: flex-start;

			.table_desktop {
				display: inline-table;
			}

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}

			div {
				padding-left: 5px;
				padding-right: 5px;
				overflow-x: initial;
			}

			.tableContent {
				background-color: #fafafa;
				border-radius: 10px;
				margin-bottom: 5px;
				min-height: 3em;

				td {
					border-top: initial;
					padding: 0px;
					padding: 5px;
				}

				@media (max-width: 820px) {
					display: none;
				}
			}

			.itemContent {
				display: none;
				padding-left: 20px;
				padding-right: 20px;
				padding-top: 10px;

				.itemRow {
					background-color: #f2f2f2;
					border-radius: 5px;
					font-size: 11px;
					padding: 10px 5px;

					&.active {
						background-color: #7fb02f;
						color: white;
					}

					&.showOpacity {
						opacity: 50%;
					}

					.itemCol {
						display: flex;
						justify-content: space-between;

						.showActions {
							border: 1px solid #81ba43;
							border-radius: 5px;
							margin-top: 5px;
							padding-top: 3px;
							padding-bottom: 3px;
						}

						.hideActions {
							border: 1px solid #ba9543;
						}
					}
				}

				.subitemRow {
					margin-top: 5px;
					background-color: #f2f2f2;
					border-radius: 5px;
					font-size: 11px;
					padding: 10px 5px;
					border: 1px solid #7fb02f;

					.itemCol {
						display: flex;
						justify-content: space-between;
					}
				}

				@media (max-width: 820px) {
					display: block;
				}
			}

			.icon {
				cursor: pointer;
			}

			.divAction {
				z-index: 1;
				background-color: white;
				position: absolute;
				min-width: 15em;
				top: 40%;
				right: 50%;
				border-radius: 5px;
				box-shadow: 5px 5px 10px #dfe1e6;

				h4 {
					font-size: 16px;
					margin-top: 5px;
					margin-left: 5px;
					color: #628822;
				}

				hr {
					margin-top: 5px;
					margin-bottom: 5px;
				}

				@media (max-width: 400px) {
					min-width: 15em;
				}

				.tableAction {
					background-color: white;
					border-radius: initial;
					min-height: initial;
					width: 100%;
					margin-bottom: 5px;

					text-align: left;
					font-size: 14px;
					border-top: 0.5px solid #628822;
					color: black;

					tr {
						cursor: pointer;

						&:hover {
							background-color: #7fb02f;

							td {
								background-color: #7fb02f;

								span,
								svg {
									color: white;
								}
							}
						}

						td {
							display: inline-flex;
							align-items: center;
							gap: 6px;

							border: 0px;
							background-color: white;
							padding: 5px;
						}
					}

					.icon {
						width: 1em;
						max-width: 1em;
					}

					.tdSpan {
						padding-left: 33px;
					}

					.tdAssign {
						background-image: url("../../assets/images/desktop/asignar.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdGenerate {
						background-image: url("../../assets/images/desktop/qrcode.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdConfirm {
						background-image: url("../../assets/images/desktop/confirm.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdDelivery {
						background-image: url("../../assets/images/desktop/checklist.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdShow {
						background-image: url("../../assets/images/desktop/show.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdPDF {
						background-image: url("../../assets/images/desktop/pdf.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdEdit {
						background-image: url("../../assets/images/desktop/editar-1.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdApproved {
						background-image: url("../../assets/images/desktop/aprobar_order.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdRejected {
						background-image: url("../../assets/images/desktop/rechazar_order.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					.tdDelete {
						background-image: url("../../assets/images/desktop/eliminar.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;
					}

					@media (max-width: 400px) {
						font-size: 15px;
					}
				}
			}
		}

		.selectUnit {
			display: inline-flex;
			background-color: #fafafa;
			padding: 0.6em;
			border-radius: 10px;
			font-size: 14px;
			font-weight: 500;
			margin-right: 10px;
			cursor: pointer;
			border: none;
			width: 100%;
		}
	}

	@media (max-width: 820px) {
		margin-right: 10px !important;
		margin-left: 10px !important;
	}
}

.modal_type_purchase {
	.option {
		text-align: center;
		border-radius: 5px;
		height: 5em;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
		padding-left: 20px;
		padding-right: 20px;
		border: 1px solid #7fb02f;
		cursor: pointer;

		&.orden {
			background-image: url("../../assets/images/icons/Purchase/orden-compra.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 70px 30px;

			&:hover {
				background-image: url("../../assets/images/icons/Purchase/orden-compra-white.svg");
			}
		}

		&.factura {
			background-image: url("../../assets/images/icons/Purchase/factura.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 70px 30px;

			&:hover {
				background-image: url("../../assets/images/icons/Purchase/factura-white.svg");
			}
		}

		&.nota_credito {
			background-image: url("../../assets/images/icons/Purchase/nota-credito.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 70px 30px;

			&:hover {
				background-image: url("../../assets/images/icons/Purchase/nota-credito-white.svg");
			}
		}

		&:hover {
			background-color: #7fb02f;
			color: white;
		}

		.icon {
			width: 2em;
			height: 2em;
		}
	}
}

.detailDiv {
	width: 100%;
	padding-left: 1em;
	padding-right: 1em;

	.detailTable {
		width: 100%;
		font-size: 15px;
		text-align: center;
		margin-bottom: 6px;

		@media (max-width: 820px) {
			display: none;
		}

		.in_use {
			color: #f53535;

			td {
				background-color: #f5353538 !important;
			}
		}

		tr {
			td {
				background-color: #f2f8ec;

				.icon {
					cursor: pointer;
				}

				.floating {
					z-index: 1;
					position: absolute;
					background-color: white;
					right: 8%;
					padding-left: 1em;
					padding-right: 1em;
					border-radius: 10px;
					min-height: 17vh;
					min-width: 23vh;
					text-align: left;
					box-shadow: 5px 5px 10px #dfe1e6;
					display: none;

					&.open {
						display: block;
					}

					&.download {
						right: 4%;
					}

					h4 {
						font-size: 14px;
						margin-top: 5px;
						color: #628822;
					}

					table {
						text-align: left;
						font-size: 14px;

						tr {
							cursor: pointer;

							td {
								background-color: white;

								.icon {
									margin-right: 10px;
								}
							}
						}
					}
				}
			}

			& td:first-child {
				border-top-left-radius: 10px;
				border-bottom-left-radius: 10px;
			}

			& td:last-child {
				border-top-right-radius: 10px;
				border-bottom-right-radius: 10px;
			}

			th {
				font-size: 12px;
				font-weight: 400;
				text-align: center;
				margin: auto;
				padding-right: 0px !important;
				padding-left: 0px !important;
			}
		}
	}
}

.modalCodes {
	.rowAssign {
		padding-top: 5px;
		padding-bottom: 15px;
	}

	.productName {
		display: flex;
		flex-direction: column;
		border-radius: 5px;
		min-height: 5em;
		justify-content: center;
		align-items: center;
		border: 1px solid #7fb02f;
		height: 100%;
	}

	.productNoAvailable {
		border: 1px solid red;
		border-radius: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding: 5px 10px;
		text-align: center;
	}

	.tableTh {
		border: initial;
		background-color: #7fb02f;
		padding: 3px 3px;
		color: white;
		text-align: center;
		font-size: 13px;
		font-weight: 400;
	}

	.tableTd {
		padding: 5px 5px;
		border-top: initial;
		border-bottom: 1px solid #dee2e6;
		text-align: center;

		.buttonSelect {
			cursor: pointer;
			background-color: #e5e5e5;
			border-radius: 5px;
			padding-top: 3px;
			padding-bottom: 3px;

			&.active {
				color: white;
				background: #7fb02f;
			}
		}
	}

	.tableTdAssign {
		padding: 5px 5px;
		border-top: initial;
		border-bottom: 1px solid #dee2e6;
		text-align: center;
	}
}

// Nueva Tabla
.table_tr {
	&.otherActive {
		color: #bbbbbb;
	}

	.table_td {
		padding-top: 5px;
		padding-bottom: 5px;
		padding-left: 0px;
		padding-right: 0px;
		border-top: 0px;

		&.first_td {
			padding-left: 5px;
			padding-right: 0px;
		}

		.table_div {
			height: 100%;
			background-color: #fafafa;
			min-height: 4em;
			padding-top: 5px;
			padding-bottom: 5px;
			display: flex;
			align-items: center;
			justify-content: center;

			&.active {
				background-color: #c7e0a9;
			}

			&.center {
				text-align: center;
			}

			&.first_div {
				border-top-left-radius: 5px;
				border-bottom-left-radius: 5px;
				justify-content: center;
				text-align: center;
			}

			&.last_div {
				border-top-right-radius: 5px;
				border-bottom-right-radius: 5px;
				justify-content: center;
				margin-right: 5px;
			}

			&.number {
				justify-content: flex-end;
				padding-right: 2em;
			}

			&.long_text {
				font-size: 13px;
				min-height: 64px;
			}

			&.pending_tag {
				color: red;
				background-color: #fdd3d3;
			}

			&.list {
				flex-direction: column;
			}
		}
	}
}

.table_detail {
	width: 100%;
	padding-left: 1em;
	padding-right: 1em;

	.td_table {
		padding-bottom: 0px;
		padding-top: 0px;
		border-top: 0px;
		border-bottom: 0px;

		.table_item {
			width: 100%;
			font-size: 15px;
			text-align: center;
			margin-bottom: 6px;

			.in_use {
				color: #f53535;

				td {
					background-color: #f5353538 !important;
				}
			}

			.table_item_tr {
				.table_item_td {
					background-color: white;
					padding-top: 5px;
					padding-bottom: 5px;
					padding-left: 0px;
					padding-right: 0px;
					border-top: 0px;

					.icon {
						cursor: pointer;
					}

					.floating {
						z-index: 1;
						position: absolute;
						background-color: white;
						right: 8%;
						padding-left: 10px;
						padding-right: 10px;
						border-radius: 10px;
						min-height: 12vh;
						min-width: 24vh;
						text-align: left;
						box-shadow: 5px 5px 10px #dfe1e6;
						display: none;

						&.open {
							display: block;
							top: 75%;
						}

						&.download {
							right: 4%;
						}

						h4 {
							font-size: 14px;
							margin-top: 5px;
							color: #628822;
						}

						table {
							text-align: left;
							font-size: 14px;
							width: 100%;
							border-top: 0.5px solid #628822;

							tr {
								cursor: pointer;

								td {
									border: 0px;
									background-color: white;
									padding: 5px;

									.icon {
										margin-right: 10px;
									}
								}
							}
						}
					}

					.div_item {
						display: flex;
						align-items: center;
						height: 100%;
						background-color: #f2f8ec;
						min-height: 3.5em;
						padding-top: 5px;
						padding-bottom: 5px;
						justify-content: center;

						.button_generate_tags {
							background-color: #dfe1e6;
							color: #212529;
							padding: 2.5px 5px;
							border-radius: 5px;
							font-size: 12px;
							border: 1px solid #a8a8a8;
						}

						&.in_use {
							color: red;
							background-color: #fdd3d3;
						}

						&.first_div {
							border-top-left-radius: 5px;
							border-bottom-left-radius: 5px;
							justify-content: center;
							align-items: center;
							display: flex;
						}

						&.last_div {
							border-top-right-radius: 5px;
							border-bottom-right-radius: 5px;
							justify-content: center;
							align-items: center;
							display: flex;
							position: relative;
						}

						&.number {
							justify-content: flex-end;
							padding-right: 2em;
						}
					}
				}

				& td:first-child {
					border-top-left-radius: 10px;
					border-bottom-left-radius: 10px;
				}

				& td:last-child {
					border-top-right-radius: 10px;
					border-bottom-right-radius: 10px;
				}

				.th_detail {
					font-size: 10px;
					font-weight: 400;
					text-align: center;
					margin: auto;
					padding-right: 0px !important;
					padding-left: 0px !important;
					padding-top: 5px;
					padding-bottom: 5px;
					border-top: 0px;
					border-bottom: 0px;
				}
			}
		}
	}
}

.document_button {
	cursor: pointer;
	width: 1.7em;
	height: 1.7em;
}

.document_modal_title {
	font-size: 1em;
}

.document_modal {
	display: flex;
	padding: 5px 0px;

	.document_number {
		color: #7fb02f;
		font-weight: bold;
		width: 10%;
	}

	.document_name {
		width: 90%;
		cursor: pointer;

		&:hover {
			color: #2977ca;
		}
	}
}
